export enum LiabilityCustomFieldKey {
	DueTo = 'dueTo',
	DueDate = 'dueDate',
	LiabilityType = 'liabilityType'
}